<template>
  <div class="coupon-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="券实例ID">
          <el-input v-model="filterForm.coupon_id" placeholder="券实例ID" clearable style="width: 120px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="会员ID">
          <el-input v-model="filterForm.crm_id" placeholder="会员ID" clearable style="width: 120px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="动作">
          <el-select v-model="filterForm.action" placeholder="全部" clearable style="width: 130px;">
            <el-option label="发放" :value="1" />
            <el-option label="锁定" :value="2" />
            <el-option label="解锁" :value="3" />
            <el-option label="核销" :value="4" />
            <el-option label="退回" :value="5" />
            <el-option label="失效" :value="6" />
            <el-option label="过期" :value="7" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="filterForm.order_dh" placeholder="订单号" clearable style="width: 180px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 流水表格（按时间倒序） -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="flowList"
        height="62vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="流水ID" width="80" align="center" />
        <el-table-column prop="comlist3" label="时间" width="160" />
        <el-table-column prop="coupon_id" label="券实例ID" width="90" align="center" />
        <el-table-column prop="template_id" label="模板ID" width="80" align="center" />
        <el-table-column prop="crm_id" label="会员ID" width="90" align="center" />
        <el-table-column label="动作" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="actionTagType(scope.row.action)">{{ scope.row.action_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态变化" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ statusText(scope.row.status_before) }}</span>
            <i class="el-icon-right" style="margin: 0 6px; color: #c0c4cc;"></i>
            <span>{{ statusText(scope.row.status_after) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="面额" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.amount">¥{{ scope.row.amount }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_dh" label="关联订单号" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.order_dh || '-' }}</template>
        </el-table-column>
        <el-table-column prop="batch_id" label="发券批次" width="90" align="center">
          <template slot-scope="scope">{{ Number(scope.row.batch_id) > 0 ? scope.row.batch_id : '-' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" width="130" show-overflow-tooltip />
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>
  </div>
</template>

<script>
import { couponFlow } from '@/api/coupon'

export default {
  name: 'CouponFlows',
  data () {
    return {
      loading: false,
      flowList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        coupon_id: '',
        crm_id: '',
        action: '',
        order_dh: ''
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    actionTagType (action) {
      const map = { 1: 'success', 2: 'warning', 3: 'primary', 4: '', 5: 'primary', 6: 'danger', 7: 'info' }
      return map[Number(action)] ?? 'info'
    },

    statusText (status) {
      const map = {
        '-1': '无（发放前）',
        0: '未使用',
        1: '已锁定',
        2: '已使用',
        3: '已过期',
        4: '已失效'
      }
      return map[String(status)] ?? String(status)
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.coupon_id) params.coupon_id = this.filterForm.coupon_id
        if (this.filterForm.crm_id) params.crm_id = this.filterForm.crm_id
        if (this.filterForm.action !== '' && this.filterForm.action !== null) params.action = this.filterForm.action
        if (this.filterForm.order_dh) params.order_dh = this.filterForm.order_dh
        const res = await couponFlow(params)
        if (res && String(res.code) === '0') {
          this.flowList = res.data || []
          this.total = res.total || 0
        } else {
          this.flowList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取券流水失败')
        }
      } catch (error) {
        console.error('获取券流水失败', error)
        this.flowList = []
        this.total = 0
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { coupon_id: '', crm_id: '', action: '', order_dh: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
